const { regexes } = require('@transfeeradev/api-enums');

const nuPagamentoSchema = {
  agency: {
    pattern: regexes.bankAccount.AGENCY_ONE,
    hasSuggestions: true
  }
};

module.exports = nuPagamentoSchema;
